module.exports = __webpack_public_path__ + "img/41.05183388.png";